import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { ItemType } from '../../../../types/DragAndDrop';
import { SORTABLE_TRANSITION } from '../../DnD/types';
import ItineraryEvent, { ItineraryEventProps } from './ItineraryEvent';

interface SortableItineraryEventProps extends ItineraryEventProps {}

function SortableItineraryEvent({
  tripId,
  event,
  card,
  emoji,
  color,
  listLabel,
  eventOrder,
  canEdit,
  eventLength,
  isMultidayEvent,
  markerNumber,
}: SortableItineraryEventProps) {
  const index = eventOrder && event.id ? eventOrder.indexOf(event.id) : -1;

  const { setNodeRef, transform, transition, isDragging, listeners, attributes } = useSortable({
    id: event.id!,
    data: { type: ItemType.EVENT, event, card, dateISO: event.startDateISO, index },
    disabled: !canEdit,
    transition: SORTABLE_TRANSITION,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : undefined,
      }}
      {...listeners}
      {...attributes}
    >
      <ItineraryEvent
        tripId={tripId}
        event={event}
        card={card}
        emoji={emoji}
        color={color}
        listLabel={listLabel}
        eventOrder={eventOrder}
        canEdit={canEdit}
        eventLength={eventLength}
        isMultidayEvent={isMultidayEvent}
        markerNumber={markerNumber}
      />
    </div>
  );
}

SortableItineraryEvent.displayName = 'SortableItineraryEvent';
export default SortableItineraryEvent;
